import Flex from '@/components/Flex';
import cx from 'classnames';
import { useState } from 'react';

import { useTimeAgo } from '@/hooks/useTimeAgo';
import { IItem } from '@/types/feed.types';
import { abbreviateNumber } from '@/utils/number';

import styles from './Details.module.scss';

interface DetailsProps {
  item: IItem;
  className?: string;
}

export const Details: React.FC<DetailsProps> = ({ item, className = '' }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleIsOpen = () => {
    setIsOpen((prevState) => !prevState);
  };

  const tagArray = item?.tags
    ? item?.tags.split(',').map((tag) => tag.replace(/\s+/g, ''))
    : [];

  const viewsFormatted = abbreviateNumber(item?.viewsCount);
  const commentsFormatted = abbreviateNumber(item?.commentsCount);
  const createdFormattedTime = useTimeAgo(item?.created);

  return (
    <>
      <div
        className={cx(styles.container, className, { [styles.open]: isOpen })}
      >
        <h1 className={styles.title} onClick={toggleIsOpen}>
          {item?.title}
        </h1>
        <div className={styles.collapsable}>
          <Flex className={styles.meta} flexDirection="column">
            <div className={styles.stats}>
              <span className={styles.views}>
                {viewsFormatted} {item?.viewsCount === 1 ? 'vista' : 'vistas'}
              </span>
              <span className={styles.comments}>
                {commentsFormatted}{' '}
                {item?.commentsCount === 1 ? 'comentario' : 'comentarios'}
              </span>
              <span className={styles.created}>
                Subido hace {createdFormattedTime}
              </span>
            </div>
          </Flex>
          {item?.description && (
            <p className={styles.description}>{item?.description}</p>
          )}
          {!!tagArray.length && (
            <div className={styles.hashtags}>
              {tagArray.map((tag) => (
                <span key={tag}>#{tag}</span>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className={styles.backdrop} onClick={toggleIsOpen} />
    </>
  );
};
